import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { RouteLoadingFallback } from './RouteLoadingFallback';
import { resolveShopOutletKey } from '../../utils/shopRouteOutletKey';

const contentFallback = (
  <RouteLoadingFallback fullScreen={false} message="Loading page..." />
);

/**
 * Local Suspense boundary for layout outlet content.
 * Shows a content-area loader while lazy route chunks resolve.
 * Outlet key forces a clean swap when the pathname changes (BrowserRouter-safe).
 */
export function PageOutletSuspense() {
  const location = useLocation();
  const outletKey = useMemo(
    () => resolveShopOutletKey(location.pathname),
    [location.pathname],
  );

  return (
    <div className="w-full">
      <Suspense fallback={contentFallback}>
        <Outlet key={outletKey} />
      </Suspense>
    </div>
  );
}

export default PageOutletSuspense;
